module.exports = __webpack_public_path__ + "static/media/loader.59ccff91.svg";